/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { CustomInitializer } from 'src/modules/sm-base/shared/custom-initializer.interface';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Comparable } from 'src/modules/utils/shared/comparable';
import { Objects } from "src/modules/utils/shared/objects";
import { Column, Entity, OneToMany, Unique } from 'typeorm';
import { CovidTest } from './covid-test.entity';

@Entity()
@Unique(["schoolClassId", "isHalfYear", "day"])
export class CovidTestDay extends SmBaseEntity implements CustomInitializer, Comparable<CovidTestDay> {
    @Column({default: 0})
    schoolClassId: number = 0;

    @Column({default: false})
    isHalfYear: boolean = false;

    @Column()
    @Type(() => Date)
    day: Date;

    @Column({default: ""})
    createUser: string = "";

    @Column()
    @Type(() => Date)
    createDate: Date;

    @OneToMany(_type => CovidTest, o => o.testDay, { cascade: true})
    @Type(() => CovidTest)
    tests: CovidTest[];

    customInitializer(): void {
        this.tests = Arrays.ensure(this.tests);
    }

    compareTo(other: CovidTestDay): number {
        return Objects.cmp(this.day, other.day);
    }

}